angular.module('TetherApp').controller('NavController', [
    '$timeout',
    '$mdSidenav',
    '$mdUtil',
    '$window',
    'navService',
    '$mdMedia',
    function (
        $timeout,
        $mdSidenav,
        $mdUtil,
        $window,
        navService,
        $mdMedia
    ) {

        let self = this;

        self.isGreaterThanSmall = $mdMedia('gt-sm');
        window.addEventListener('resize', function () {
            self.isGreaterThanSmall = $mdMedia('gt-sm');
        });

        self.messages = {};

        self.toggleLeft = buildToggler('left');
        self.toggleRight = buildToggler('right');
        self.unreadCount = 0;

        self.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        self.loadData = function(client) {
            navService.getUnreadCount({client: client})
                .then(onUnreadCountSuccess, onError);
        };

        let onUnreadCountSuccess = function (data) {
            self.unreadCount = data.count;
        };

        let onError = function(reason) {
            self.error = 'Could not fetch the data.';
        };

        function buildToggler(navID) {
            let debounceFn =  $mdUtil.debounce(
                function(){
                    $mdSidenav(navID)
                        .toggle()
                        .then(function () {
                            // Menu toggle done
                        });
                },
                300
            );

            self.unreadCount = 0;
            return debounceFn;
        }



    }
]);

angular.module('TetherApp').controller('LeftCtrl', [
    '$scope', '$timeout', '$mdSidenav', '$mdMedia',
    function($scope, $timeout, $mdSidenav, $mdMedia) {
        $scope.isGreaterThanSmall = $mdMedia('gt-sm');
        window.addEventListener('resize', function () {
            $scope.isGreaterThanSmall = $mdMedia('gt-sm');
        });

        $scope.close = function () {
            $mdSidenav('left').close()
                .then(function () {
                    // Close LEFT is done
                });
        };
    }
]);

angular.module('TetherApp').controller('PrivacyPolicyController', [
    '$scope', '$mdDialog',
    function($scope, $mdDialog) {

        let self = this;

        let DialogController = function ($mdDialog) {
            let dCtrl = this;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };

    }
]);

angular.module('TetherApp').controller('RightCtrl', [
    '$scope', '$timeout', '$mdSidenav', 'contactService',
    function(
        $scope,
        $timeout,
        $mdSidenav,
        contactService
    ) {
        $scope.isSuccessful = false;
        $scope.errors = [];
        $scope.message = '';
        $scope.emailType = 'programSupport';

        $scope.sendEmail = function () {
            $scope.errors = [];
            contactService.sendTechnical($scope.message, window.location.href)
                .then(onSend, onError);
        };

        let onSend = function (data) {
            $scope.message = '';
            $scope.isSuccessful = true; // show message
            setTimeout(function () {
                $scope.isSuccessful = false; // hide message
                $mdSidenav('right').close(); // close nav
            }, 3000);
        };

        let onError = function (data) {
            $scope.errors = data.data.errors;
        };

        $scope.close = function () {
            $mdSidenav('right').close()
                .then(function () {
                    // Do nothing
                });
        };

    }
]);

angular.module('TetherApp').controller('LeftListCtrl', [
    '$window', '$location', '$mdSidenav', 'navService',
    function($window, $location, $mdSidenav, navService) {

        let self = this;
        self.isAssetsOpen = false;
        self.isAdminOpen = false;
        self.isOpsOpen = false;
        self.isFraudOpen = false;
        self.isSupportOpen = false;
        self.unreadCount = 0;

        self.close = function () {
            $mdSidenav('left').close()
                .then(function () {
                    // Close LEFT is done
                });
        };

        self.toggleAssets = function () {
            self.isAssetsOpen = ! self.isAssetsOpen;
        };

        self.toggleAdmin = function () {
            self.isAdminOpen = ! self.isAdminOpen;
        };

        self.toggleOps = function () {
            self.isOpsOpen = ! self.isOpsOpen;
        };

        self.toggleFraud = function () {
            self.isFraudOpen = ! self.isFraudOpen;
        };

        self.toggleSupport = function () {
            console.log('hit');
            self.isSupportOpen = !self.isSupportOpen;
        }

        self.loadData = function(client) {
            navService.getUnreadCount({client: client})
                .then(onUnreadCountSuccess, onError);
        };

        let onUnreadCountSuccess = function (data) {
            self.unreadCount = data.count;
        };

        let onError = function(reason) {
            self.error = 'Could not fetch the data.';
        };

    }
]);



